export default {
  pageTitle: "Huahao International (Hong Kong) - Global Excellence, Local Service",
  nav: {
    home: "Home",
    about: "About Us",
    business: "Business Scope",
    advantages: "Core Advantages",
    partners: "Our Partners",
    aboutSubmenu: {
      companyIntro: "Company Profile",
      contact: "Contact Us",
    },
    businessSubmenu: {
      smartProducts: {
        title: "Smart Products",
        items: {
          smartWearable: "Smart Wearable",
          personalTerminal: "Personal Terminal",
          homeTerminal: "Home Terminal",
          smartRobot: "Smart Robot",
        },
      },
      electronicProducts: {
        title: "Electronic Products",
        items: {
          computer: "Computer",
          mobile: "Mobile",
          pcba: "PCBA",
          ic: "Integrated Circuit",
          newMaterial: "New Material",
        },
      },
      softwareProducts: {
        title: "Software Products",
        items: {
          aiSoftware: "AI Software",
          techService: "Tech Development & Services",
        },
      },
    },
  },
  palette: {
    title: "Website Color Palette",
    presetThemes: "Preset Themes",
    customColors: "Custom Colors",
    headerColorStart: "Header Navigation Start",
    headerColorEnd: "Header Navigation End",
    gradientStart: "Gradient Start Color",
    gradientEnd: "Gradient End Color",
    iconGradientStart: "Icon Gradient Start",
    iconGradientEnd: "Icon Gradient End",
    accent: "Accent Color",
    accentLight: "Light Accent Color",
    preview: "Color Preview",
    save: "Save Config",
    export: "Export Config",
    reset: "Reset to Default",
    saveSuccess: "Color scheme saved!",
    exportSuccess: "Config exported!",
    resetConfirm: "Are you sure you want to reset to default colors?",
    resetSuccess: "Reset to default colors!",
    warning: "Warning",
    confirm: "Confirm",
    cancel: "Cancel",
    sectionTitleColor: "Section Title Color",
  },

  hero: {
    slide1: {
      title: "Global Excellence, Local Service",
      subtitle: "Huahao International, your comprehensive product and supply chain partner. Committed to connecting global quality resources, providing diversified commodity solutions from basic raw materials to intelligent technology for various industries.",
      button: "Contact Us",
    },
    slide2: {
      title: "Safe, Fast, Accurate, Professional",
      subtitle: "Deeply integrating global vision with localized services to become the most trusted product library and solution partner for customers.",
      button: "Learn More",
    },
    slide3: {
      title: "Cross-Industry Comprehensive Trading Enterprise",
      subtitle: "From traditional manufacturing to cutting-edge technology, one-stop solution for your diverse procurement needs.",
      button: "Inquire Now",
    },
  },
  business: {
    title: "Business Scope",
    subtitle: "Focus on technology innovation and drive digital transformation",
    items: [
      {
        icon: "fas fa-brain",
        title: "Artificial Intelligence Software",
        description: "Providing advanced AI solutions to help enterprises achieve intelligent upgrades and digital transformation",
      },
      {
        icon: "fas fa-robot",
        title: "Intelligent Robotics",
        description: "Integrating cutting-edge robotics technology to provide innovative solutions for industrial automation and service scenarios",
      },
      {
        icon: "fas fa-microchip",
        title: "Integrated Circuits",
        description: "Supplying high-quality integrated circuit products to support electronic product manufacturing and R&D needs",
      },
      {
        icon: "fas fa-memory",
        title: "Electronic Components",
        description: "Providing comprehensive electronic component selection to ensure product performance and reliability",
      },
      {
        icon: "fas fa-code",
        title: "Technology Development & Services",
        description: "Professional technical team providing customized development services to meet diverse technical requirements",
      },
      {
        icon: "fas fa-atom",
        title: "Advanced Materials",
        description: "Offering cutting-edge materials including nanomaterials, superconductors, and polymer materials to drive industrial innovation",
      },
    ],
  },
  advantages: {
    title: "Core Advantages",
    subtitle: "Professional, Reliable, Trustworthy Global Trading Partner",
    items: [
      {
        title: "Diversified Product Portfolio",
        description: "From daily consumption to industrial support, from traditional manufacturing to cutting-edge technology, we provide a rich cross-industry product selection. One-stop solution for your diverse procurement needs, simplifying supplier management.",
        icon: "fas fa-boxes",
        features: ["Cross-industry Product Selection", "One-stop Procurement Service", "Simplified Supplier Management"],
      },
      {
        title: "Deep Global Sourcing Network",
        description: "We have established solid direct partnerships with quality factories and brands worldwide. Controlling product quality and cost from the source, bringing you the most competitive prices.",
        icon: "fas fa-globe-americas",
        features: ["Direct Factory Cooperation Worldwide", "Source Quality & Cost Control", "Most Competitive Pricing"],
      },
      {
        title: "Professional Selection & Quality Control",
        description: "Our team possesses professional market knowledge, providing product selection advice and market insights. Strict quality control processes throughout, ensuring every delivered product meets expected standards.",
        icon: "fas fa-certificate",
        features: ["Professional Market Knowledge & Insights", "Strict Quality Control Process", "Ensuring Product Standards"],
      },
      {
        title: "Agile Customized Services",
        description: "Understanding that standard solutions are not one-size-fits-all. Whether it's special specifications, small batch trials, or co-branded development, we provide flexible and responsive services, tailoring the most suitable trading solutions.",
        icon: "fas fa-cogs",
        features: ["Custom Specifications", "Small Batch Trial Support", "Tailored Solutions"],
      },
    ],
  },
  about: {
    title: "About Us",
    subtitle: "Deep expertise in global trade, building one-stop product and supply chain solutions",
    companyProfile: "Company Profile",
    description1: 'Huahao International (Hong Kong) Co., Limited is a cross-industry comprehensive trading enterprise. Adhering to the concept of "Global Resources, Local Service", we focus on providing customers with comprehensive product solutions from basic raw materials to cutting-edge technology.',
    description2: "At Huahao, trade is not just about buying and selling goods, but also about building trust and creating value. We are committed to creating long-term and stable value for every customer through rigorous quality control, professional market analysis, and flexible customized services, helping your business grow continuously.",
    stats: [
      { number: "10+", label: "Years of Industry Experience" },
      { number: "20+", label: "Business Areas" },
      { number: "500+", label: "Partner Clients" },
      { number: "100%", label: "Customer Satisfaction" },
    ],
  },

  // Company Info Detail Page
  companyInfo: {
    headerTag: "ABOUT US",
    title: "About Us",
    subtitle: "Connecting the World. Advancing the Future. Creating Shared Value",
    stats: [
      { key: "years", icon: "el-icon-trophy", suffix: "%", label: "Customer Satisfaction", target: 100 },
      { key: "countries", icon: "el-icon-map-location", suffix: "+", label: "Countries Covered", target: 68 },
      { key: "partners", icon: "el-icon-user", suffix: "+", label: "Partners", target: 500 },
      { key: "volume", icon: "el-icon-data-line", suffix: "M", label: "Annual Trade Volume", target: 28 },
    ],
    intro: {
      title: "Professional International Trade Service Provider",
      paragraphs: ["Founded in 2025 and headquartered in Hong Kong, China, Huahao is an international trading company specializing in intelligent product services. The company has established a comprehensive product portfolio covering smartphones, tablets, laptops, smartwatches/bands, smart glasses, and other intelligent devices. Its business spans multiple countries and regions, enabling strong global product service capabilities.", "Looking ahead, Huahao will continue to focus on the intelligent products sector, steadily enhancing its service capabilities and delivering higher-quality solutions to customers worldwide, creating greater value on a global scale."],
      features: ["Professional Team", "Global Network", "Quality Assurance"],
    },
    timeline: {
      title: "Fifteen Years of Progress Together",
      items: [
        { year: "2010", title: "Setting Sail", desc: "Company established in Shanghai, focusing on international trade services" },
        { year: "2013", title: "Expanding Horizons", desc: "Business expanded to Southeast Asia and European markets" },
        { year: "2016", title: "Digital Empowerment", desc: "Introduced intelligent supply chain management system" },
        { year: "2020", title: "Global Presence", desc: "Business coverage reached 68 countries and regions" },
        { year: "2025", title: "Smart Future", desc: "Building an AI-driven intelligent trade platform" },
      ],
    },
    services: {
      title: "One-Stop International Trade Services",
      items: [
        { icon: "el-icon-shopping-cart-2", title: "Global Sourcing", desc: "Integrating quality suppliers worldwide, providing one-stop procurement services" },
        { icon: "el-icon-connection", title: "Supply Chain Management", desc: "End-to-end supply chain solutions with full visibility" },
        { icon: "el-icon-suitcase", title: "Trade Execution", desc: "Ensuring smooth order fulfillment through full-process trade coordination" },
        { icon: "el-icon-wallet", title: "Trade Financing", desc: "Flexible financing solutions to support business cash flow" },
        { icon: "el-icon-data-analysis", title: "Market Analysis", desc: "In-depth market research to capture business opportunities" },
        { icon: "el-icon-document", title: "Business Consulting", desc: "Professional trade consulting for risk mitigation and compliance" },
      ],
    },
    values: {
      title: "Our Commitment",
      intro: "Adhering to the principles of professionalism, integrity, and innovation to provide excellent service experience for our clients",
      items: [
        { title: "Integrity First", desc: "Winning trust through integrity, building long-term partnerships" },
        { title: "Professional & Efficient", desc: "Professional team delivering efficient services, creating maximum value" },
        { title: "Continuous Innovation", desc: "Constantly innovating service models, leading industry development" },
        { title: "Win-Win Cooperation", desc: "Growing together with partners, achieving mutual benefits" },
      ],
    },
    cta: {
      title: "Start a New Chapter in Global Trade",
      subtitle: "Looking forward to partnering with you to create a brilliant future",
      button: "Contact Us",
    },
  },
  partners: {
    title: "Our Partners",
    subtitle: "We have established long-term stable partnerships with globally renowned enterprises, working together to provide quality products and services to customers",
  },
  strategy: {
    title: "Development Strategy",
    subtitle: "",
    description: "Facing future development, customer-centric, continuously innovating business models. Committed to building a global industry platform and deepening cooperation with partners worldwide. Through digital transformation, we enhance supply chain efficiency and service quality, creating greater value for customers and achieving sustainable development.",
  },
  footer: {
    contact: "Contact Information",
    quickLinks: "Quick Links",
    company: "Company",
    companyName: "Huahao International (Hong Kong) Co., Limited",
    slogan1: "Innovation Leads, Technology Empowers",
    slogan2: "Quality Life, Benefit the World",
    motto: "Empower global customers with innovation and technology",
    address: "1325 13/F Golden Industrial Bldg, Kwai Fong, NT, Hong Kong",
    phone: "+852 53031585(HK)",
    email: "+852 3709 7014",
    copyright: "© Copyright 2025. Huahao International (Hong Kong) Co., Limited",
    icp: "ICP Registration",
  },
  messages: {
    contactSuccess: "Thank you for your attention, we will contact you as soon as possible!",
    learnMore: "Thank you for your interest!",
    inquireNow: "Thank you for your inquiry, our staff will contact you shortly!",
  },

  // AI Software Page
  aiSoftware: {
    pageTitle: "Artificial Intelligence Software",
    pageIntro: "Based on cutting-edge artificial intelligence technology, providing full-stack AI software solutions covering vision, speech, algorithms, and applications",
    categories: [
      {
        title: "Vision AI",
        items: [
          { name: "Computer Vision", desc: "High-precision image recognition and scene understanding" },
          { name: "Face Recognition", desc: "Millisecond-level face detection and identity verification" },
          { name: "OCR Text Recognition", desc: "Multilingual intelligent text extraction" },
        ],
      },
      {
        title: "Speech AI",
        items: [
          { name: "Speech Recognition", desc: "Real-time speech-to-text, supporting multiple dialects" },
          { name: "Speech Synthesis", desc: "Natural and smooth TTS voice output" },
          { name: "Intelligent Voice Assistant", desc: "Multi-turn dialogue and intelligent voice interaction" },
        ],
      },
      {
        title: "Algorithm Platform",
        items: [
          { name: "Machine Learning Platform", desc: "One-stop model training and deployment platform" },
          { name: "Deep Learning Framework", desc: "High-performance neural network computing engine" },
          { name: "AI Algorithm Services", desc: "Ready-to-use algorithm API services" },
        ],
      },
      {
        title: "Intelligent Applications",
        items: [
          { name: "Intelligent Recommendation System", desc: "Precise personalized content recommendation engine" },
          { name: "Natural Language Processing", desc: "Text analysis and intelligent semantic understanding" },
          { name: "Intelligent Customer Service System", desc: "24/7 AI customer service solution" },
        ],
      },
    ],
  },

  // Smart Robot Page
  smartRobot: {
    pageTitle: "Smart Robotics",
    pageIntro: "Huahao International specializes in the field of intelligent robotics. Leveraging advanced AI algorithms, precision sensor technology, and intelligent control systems, we provide customers with comprehensive robot product solutions covering service, education, and home cleaning scenarios. With innovative technology, we empower smart living and create a more convenient and intelligent future lifestyle for consumers.",
    sections: [
      {
        title: "Service Robots",
        paragraphs: ["Combining advanced artificial intelligence technology, computer vision, natural language processing, and autonomous navigation systems, we provide customers with comprehensive service robot solutions featuring intelligent interaction, precise recognition, and flexible mobility. Products are widely used in commercial reception, medical assistance, hotel services, and other scenarios.", "Through deep learning algorithms and multi-sensor fusion technology, we achieve natural human-machine interaction, environmental perception and obstacle avoidance, and autonomous task execution, providing efficient and reliable intelligent service experiences for various industries."],
      },
      {
        title: "Educational Robots",
        paragraphs: ["Focusing on STEAM education and programming teaching, we integrate robotics technology, programming education, and artificial intelligence to provide engaging intelligent educational products for youth. Supporting multiple programming methods including graphical programming and Python programming, cultivating students' innovative thinking and hands-on abilities.", "Equipped with rich sensor modules and actuators, supporting project-based learning and competition activities, helping students master robotics technology, programming logic, and AI applications in practice, inspiring interest and exploratory spirit in technology."],
      },
      {
        title: "Robotic Vacuum Cleaners",
        paragraphs: ["Utilizing LiDAR SLAM technology and visual navigation systems to achieve precise mapping, intelligent path planning, and efficient cleaning coverage. Combined with strong suction power, intelligent mopping systems, and automatic dust collection functions, providing users with comprehensive home cleaning solutions.", "Through AI algorithms achieving obstacle recognition and intelligent avoidance, supporting multi-floor map management, scheduled appointments, remote control, and other smart functions. Low-noise design and long battery life make home cleaning easier and more convenient, freeing up more time for users to enjoy life."],
      },
    ],
  },

  // Tech Service Page
  techService: {
    pageTitle: "Technology Development & Services",
    pageIntro: "Providing enterprise-level software system solutions to facilitate digital transformation and business growth",
    systems: [
      {
        title: "CRM System",
        subtitle: "Customer Relationship Management",
        features: ["Full customer lifecycle management", "Sales funnel visualization", "Intelligent opportunity follow-up reminders", "Multi-channel customer data integration", "Automated marketing workflows", "Data reports and decision support"],
      },
      {
        title: "SCRM System",
        subtitle: "Social Customer Relationship Management",
        features: ["Social media customer management", "Deep WeChat Work integration", "Private domain traffic operation tools", "Automated community management", "Precise customer tagging and profiling", "Social interaction data analysis"],
      },
      {
        title: "SaaS System",
        subtitle: "Software as a Service",
        features: ["Cloud deployment ready to use", "Multi-tenant architecture design", "Elastic scaling pay-as-you-go", "Data security and backup", "Cross-platform seamless collaboration", "Continuous updates and maintenance"],
      },
    ],
  },

  // Smart Wearable Page
  smartWearable: {
    pageTitle: "Smart Wearables",
    pageIntro: "With keen market insight, Huahao has pioneered entry into the sports and health field. Analyzing industry trends, we continuously excel in products such as smartwatches, smart bands, and TWS earphones. Utilizing outstanding technological innovation and precision manufacturing capabilities, we provide customers with comprehensive solutions that exceed expectations, creating a richer digital health lifestyle for consumers.",
    sections: [
      {
        title: "Smartwatches",
        paragraphs: ["Possessing industry-leading full-domain software development capabilities, extensive experience in system development of mainstream sports watches and calling watches, and full-platform complex architecture design. With industry-leading high-density component layout technology, maximizing product space utilization, and mature 5ATM waterproof design/testing throughout the entire production stage.", "Globalized product customization and flexible manufacturing delivery capabilities fully meet customer needs."],
      },
      {
        title: "Smart Bands",
        paragraphs: ["Rich experience and technology in multiple power consumption optimization, sports health design development and algorithm debugging, and multi-platform development.", "Through long battery life, low power consumption design, miniaturization design, waterproof and oil-proof design, antenna solution system design, and flexible manufacturing delivery capabilities, effectively meeting diverse customer needs."],
      },
      {
        title: "TWS Earphones",
        paragraphs: ["Possessing industry-leading acoustic design, debugging, testing, and audio algorithm capabilities. Adopting advanced technologies such as intelligent noise cancellation and high-definition audio transmission, bringing high-quality music enjoyment even in noisy environments, presenting pure high-fidelity sound quality.", "Combined with rich overall design experience in antennas, low power consumption, waterproofing, and service experience with mainstream Android customers, providing customers with comprehensive acoustic solutions from entry-level to flagship-level."],
      },
    ],
  },

  // Home Terminal Page
  homeTerminal: {
    pageTitle: "Home Terminals",
    pageIntro: "Providing integrated solutions for home terminal products from market research, product concept, ID design to R&D and manufacturing. In product areas such as VR & AR, smart speakers, smart locks, and TVs, we provide customers with high-quality, cost-effective comprehensive solutions, creating a more relaxed, warm, and immersive extraordinary experience for consumers.",
    sections: [
      {
        title: "VR & AR",
        paragraphs: ["Leveraging our strong integrated hardware and software design and precision manufacturing capabilities, we provide customers with VR&AR one-stop system solutions, covering overall design solutions including optics, acoustics, power consumption, RF, antennas, stacking, structure, software underlying drivers, 6DoF algorithms, eye-tracking algorithms, facial recognition algorithms, as well as overall manufacturing solutions including components, molds, injection molding, calibration, assembly, and automation.", "Perfectly presenting 4K 360° images for consumers, bringing a more comfortable and immersive extraordinary experience."],
      },
      {
        title: "Smart Speakers",
        paragraphs: ["Mature touch and high-definition large-screen display technology, multi-microphone array design and noise reduction technology, high-power large speaker and cavity integrated design technology provide effective guarantee for smart speaker R&D and production.", "Multi-hardware platform and Android system development experience further accelerates product development and delivery. With professional audio laboratories and subjective and objective evaluation methods and capabilities, effectively meeting customer high-quality requirements and experiences."],
      },
      {
        title: "Smart Locks",
        paragraphs: ["With years of technical accumulation in fingerprint, camera, touch, screen, WIFI, and Bluetooth, security and anti-dismantle technology, strong industrial design capabilities, and industry integration power for lock cores and lock bodies, quickly standing out in the smart lock field.", "Products cover all price ranges, fully meeting diverse customer needs."],
      },
      {
        title: "TV",
        paragraphs: ["Mainly engaged in the R&D, production, and delivery of products such as boards and TV sticks. Through continuous provision of innovative products and services, currently covering TV, Monitor, commercial display complete machines, and customized product development and design according to customer needs.", "Helping customers provide users with better products and services at better costs, faster speeds, and higher quality."],
      },
    ],
  },

  // Personal Terminal Page
  personalTerminal: {
    pageTitle: "Personal Terminals",
    pageIntro: "From product customization to platform capabilities, Huahao International continues to deepen its expertise in the personal terminal field, building an intelligent product system covering multiple terminal forms, providing global customers with one-stop solutions from R&D to mass production.",
    sections: [
      {
        title: "Smartphones & Tablets",
        paragraphs: ["As an important component of the personal terminal field, Huahao continues to advance technological innovation and manufacturing capability upgrades in smartphones and tablets, establishing a flexible and efficient multi-regional delivery system.", "Focusing on different customer product positioning and market demands, Huahao deeply analyzes end-user usage habits, mainstream market trends, and new technology evolution directions, combining comprehensive considerations of performance, cost, and reliability to create competitive high-quality terminal products for customers."],
      },
      {
        title: "Laptops",
        paragraphs: ["With continuous technological investment and intelligent manufacturing capability building, Huahao has gradually formed a mature product development and delivery system in the laptop field.", "Focusing on core demands of thinness, high performance, and reliability, Huahao continuously breaks through technical boundaries in structural design, cooling solutions, and overall integration, collaborating with customers to create laptop products that balance performance and quality."],
      },
    ],
  },
  // 在 en.js 中添加 contact 部分
  contact: {
    pageTitle: "Contact Us",
    breadcrumb: {
      home: "Home",
      contact: "Contact Us",
    },
    form: {
      title: "Get In Touch",
      description: "Feel free to contact us for any questions, business inquiries, or partnership opportunities. We will get back to you promptly with professional assistance.",
      hongKongOffice: "Hong Kong Office",
      officeLine: "Office Line",
      tel: "Tel",
      email: "Our Mail",
      coordinates: "Coordinates",
      latLng: "(Latitude, Longitude)",
    },
    map: {
      baidu: "Baidu Map",
      amap: "Amap",
      google: "Google Maps",
      copyCoordinates: "Copy Coordinates",
      copySuccess: "Coordinates copied to clipboard:",
      copyFailed: "Copy failed, please copy manually:",
      copyError: "Copy failed, coordinates are:",
    },
  },
};
